import React from 'react'
import Header from './Header'
import Hero from './Hero.js'
import Cards from './Cards.js'
import About from './About.js'
import Numbers from './Numbers.js'
import Services from './Services.js'
import Appointment from './Appointment.js'
import Departments from './Departments.js'
import Doctors from './Doctors.js'
import Questions from './Questions.js'
import Swiperr from './Swiperr.js'
import Gallery from './Gallery.js'
import Contact from './Contact.js'
import Footer from './Footer.js'

const HomePage = () => {
    return (
        <>
            <Header />
            <Hero />
            <Cards />
            <About />
            <Numbers />
            <Services />
            <Appointment />
            <Departments />
            <Doctors />
            <Questions />
            <Swiperr />
            <Gallery />
            <Contact />
            <Footer />
        </>
    )
}


export default HomePage